import { getProductPermalink } from './utils/products'

export const addToCart = ({
	product,
	config: {
		sizebay: { tenantId },
	},
	store,
}) => {
	try {
		if (typeof window.Sizebay.events.addToCart === 'function') {
			const payload = { products: [{ permalink: getProductPermalink(product, { store }) }] }
			window.Sizebay.events.addToCart(payload, tenantId)
		}
	} catch (e) {
		console.error(e)
	}
}
